export { Caption, Table, TBody, TD, TFoot, TH, THead, TR } from "#bacons-table";
export { SlideGlyph, SlideToneSwatch } from "#slide-table";
